import { useEffect, useState } from "react";
import { BigNumberish, ethers } from "ethers";

import { useContractRead } from "wagmi";
import DashboardItem from "./dashboardItem";
import { Chain, Chains, Token, WBTCBalanceABI } from "../data";
import { convertBitcoinNum } from "../../utils/util";

const BaseDashBoard = (): JSX.Element => {
  const [pol_sats, set_pol_sats] = useState(0);

  const { refetch: fetchPolWbtc } = useContractRead({
    chainId: Chains[Chain.POL].chainId,
    address: Chains[Chain.POL].wbtcAddr[Token.WBTC].addr as `0x${string}`,
    abi: WBTCBalanceABI,
    functionName: "balanceOf",
    args: [Chains[Chain.POL].contractAddr],
    enabled: false,
  });

  const fetchUSD = () => {
    fetchPolWbtc().then((res) => {
      console.log("fetchPolWbtc:", (res.data as BigNumberish).toString());
      console.log("sats:", parseFloat(
        ethers.formatUnits(
          (res.data as BigNumberish).toString(),
          Chains[Chain.POL].wbtcAddr[Token.WBTC].decimal
        )
      ))
      set_pol_sats(
        // Math.floor(
        parseFloat(
          ethers.formatUnits(
            (res.data as BigNumberish).toString(),
            Chains[Chain.POL].wbtcAddr[Token.WBTC].decimal
          )
        )
        // )
      );
    });
  };
  useEffect(() => {
    fetchUSD();
    const i = setInterval(() => {
      fetchUSD();
    }, 5000);
    return () => {
      clearInterval(i);
    };
  }, []);

  //BSC


  return (
    <div className=" select-none w-full h-full flex flex-col items-center overflow-hidden">
      <div className="w-full h-screen flex flex-col items-center overflow-auto">
        <p
          className="mt-20 mb-6 flex items-end text-[#fff] text-xl lg:text-3xl"
          style={{ height: "10%" }}
        >
          TOTAL SATs: {pol_sats} <span className="text-sm">{"(≈ " + convertBitcoinNum(pol_sats) + "₿)"}</span>
        </p>
        <div className="flex flex-col w-full items-center lg:flex-row lg:justify-center">
          <DashboardItem
            contractUrl={
              "https://polygonscan.com/address/" +
              Chains[Chain.POL].contractAddr
            }
            chainName="Polygon"
            totalVal={pol_sats}
            SATs={pol_sats}
            addr={Chains[Chain.POL].contractAddr}
          ></DashboardItem>
        </div>
      </div>
    </div>
  );
};
export default BaseDashBoard;
